export const QUERY_KEY_EMPLOYEE_INFORMATION = 'employee/information';
